import PublicationPage from "./PubsPage"

export default PublicationPage
